import React from 'react';
import { AccordionProvider } from './AccordionProvider';
import AccordionContent from './AccordionContent';
import AccordionTrigger from './AccordionTrigger';
/** @public */
var Accordion = function (_a) {
    var _b = _a.open, open = _b === void 0 ? false : _b, _c = _a.shouldAnimate, shouldAnimate = _c === void 0 ? true : _c, _d = _a.shouldMapOpenPropToContent, shouldMapOpenPropToContent = _d === void 0 ? false : _d, children = _a.children;
    return (React.createElement(AccordionProvider, { open: open, shouldAnimate: shouldAnimate, shouldMapOpenPropToContent: shouldMapOpenPropToContent }, children));
};
Accordion.Trigger = AccordionTrigger;
Accordion.Content = AccordionContent;
export default Accordion;
//# sourceMappingURL=Accordion.js.map